
import React, { memo } from 'react';
import { API_BASE_URL } from '../lib/constans';

const Banner = ({ state }) => {
    // Validar que state tenga los datos necesarios
    if (!state || !state.image) {
        return (
            <div className="flex items-center justify-center h-screen bg-gradient-to-b from-gray-800 to-gray-900">
                <p className="text-white text-lg">Cargando información del yate...</p>
            </div>
        );
    }

    return (
        <div className="flex md:justify-start transition-all h-screen relative">
            <img
                src={`${API_BASE_URL}${state.image}`}
                alt={state.name || 'Yacht Banner'}
                width={1200}
                height={800}
                sizes="(max-width: 768px) 100vw, 1200px"
                className="absolute top-0 left-0 w-full h-full object-cover object-center"
            />
            <div className="absolute top-0 left-0 w-full h-full bg-black/30" />
            <div className="flex px-10 md:px-20 flex-col z-10 transition-all justify-center md:items-start text-white w-full">
                <div className="md:p-5 flex flex-col md:items-start gap-5 ">
                    <h1 className="text-3xl md:text-6xl leading-none text-center md:text-left font-bold">
                        {state.title || 'Yacht'}
                    </h1>
                    <h2 className="font-normal text-center md:text-left text-lg md:text-2xl leading-none mt-[-10px] mb-24 md:mb-10">
                        {state.text || ''}
                    </h2>
                   
                </div>
            </div>
        </div>
    );
};


export default memo(Banner);
